// Mock Project entity for development
export const Project = {
  async filter(conditions, orderBy, limit) {
    const projects = [
      {
        id: 'proj-1',
        title: 'K8in — Cloud-Native Distributed Quiz Platform',
        description:
          'Production-grade real-time quiz platform built on Kubernetes. Eight independent microservices (Go + Python) communicating over gRPC, routed through an Envoy API gateway with MetalLB load balancing. Each service runs its own database operator (MySQL InnoDB Cluster, MongoDB Sharded, PostgreSQL CloudNativePG, Redis Sentinel) on a local k3d cluster, with Prometheus + Grafana for observability.',
        technologies: ['Kubernetes', 'Go', 'Python', 'gRPC', 'Envoy Gateway', 'MetalLB', 'MySQL InnoDB Cluster', 'MongoDB Sharded', 'PostgreSQL (CloudNativePG)', 'Redis Sentinel', 'Redis Streams', 'Prometheus', 'Grafana', 'Helm', 'k3d', 'HPA'],
        image_url: '',
        live_url: '',
        github_url: 'https://github.com/Auswahlenn/Cloud-Distributing-Computing',
        featured: true,
        order_index: 1,
      },
      {
        id: 'proj-2',
        title: 'Consumer Electronics Comparison Platform',
        description:
          'Full-stack product comparison web app for consumer electronics (mobiles, laptops, tablets, monitors). Features a normalized 3NF relational schema decomposed from a flat CSV dataset, a batch import pipeline (930+ rows, chunked inserts, deduplication), and a Flask backend. Schema migrations wrapped in ACID transactions with foreign key constraints and composite unique constraints for data integrity.',
        technologies: ['PostgreSQL', 'Python'],
        image_url: '',
        live_url: '',
        github_url: 'https://github.com/Auswahlenn/Supabase-DBMS',
        featured: false,
        order_index: 2,
      },
      {
        id: 'proj-3',
        title: 'Smart Building IoT Monitoring System',
        description:
          'Production-grade IoT monitoring platform deployed in a live university lab. Hub-and-spoke MQTT topology connects LoRaWAN, Zigbee, and IP camera ecosystems through a single Mosquitto broker. AI vision pipeline on NVIDIA Jetson Orin Nano runs YOLOv8 person detection with GPU-accelerated RTSP output (h264_nvenc) and a 7-frame rolling median filter for occupancy smoothing. Sensor data streams into InfluxDB + Grafana; Telegram bot handles CO2, water leak, and panic button alerts.',
        technologies: ['Python', 'MQTT', 'Docker', 'YOLOv8', 'Grafana', 'InfluxDB', 'TensorFlow', 'Home Assistant', 'Tailscale'],
        image_url: '',
        live_url: '',
        github_url: 'https://github.com/Auswahlenn/IoT-Temperature-Humidity',
        featured: false,
        order_index: 3,
      },
      {
        id: 'proj-4',
        title: 'IoT Cloud-Native Data Distribution System — Dell Cloud Native Finalist',
        description:
          'Cloud-native evolution of the Smart Building IoT Monitoring System, extended and submitted for the Dell Cloud Native competition. Lifts the on-premises MQTT architecture to a fully managed GCP pipeline: sensor data flows through Cloud Dataflow (Flex Template) into Pub/Sub, ingested by a horizontally autoscaled Go gRPC server (HPA 2–10 pods on GKE), and persisted in a CloudNativePG PostgreSQL cluster with automatic failover. Entire GCP stack provisioned via five Terraform modules with zero manually provisioned resources; Grafana surfaces application metrics (PostgreSQL) and infrastructure metrics (Prometheus + kube-state-metrics) in a unified dashboard.',
        technologies: ['GCP', 'Kubernetes', 'Terraform', 'Go', 'Python', 'gRPC', 'PostgreSQL', 'Grafana', 'Prometheus', 'Docker'],
        image_url: '',
        live_url: '',
        github_url: 'https://github.com/Auswahlenn/PSD_Cloud_Project',
        featured: true,
        order_index: 4,
      },
      {
        id: 'proj-5',
        title: 'IoT Event Streaming Platform — Chitralada Technology Institute',
        description:
          'Internship project at the Faculty of Digital Technology, Bangkok (Oct 2023 – Feb 2024). Implemented an IoT event streaming reference architecture: ESP32 sensors publish over MQTT to Mosquitto, bridged into Apache Kafka via Kafka Connect. Kafka Streams aggregates telemetry by sensor, location, and 5-minute rolling time windows. Processed events persist in MongoDB; Prometheus scrapes metrics; Grafana surfaces unified real-time dashboards. Installed and configured 10 ESP32 devices across two building levels, each with temperature, humidity, pressure, and LDR sensors.',
        technologies: ['Kafka', 'MQTT', 'MongoDB', 'Prometheus', 'Grafana', 'Docker'],
        image_url: '',
        live_url: '',
        github_url: '',
        featured: false,
        order_index: 5,
      },
      {
        id: 'proj-6',
        title: 'IoT Home Automation System',
        description:
          'Distributed IoT architecture for environmental monitoring and smart home control. Raspberry Pi clients collect DHT11, soil moisture, and servo-driven door sensor data, publishing over MQTT to a Mosquitto broker. Telegraf subscribes to MQTT topics and writes metrics to InfluxDB every 5 seconds; Home Assistant queries InfluxDB via Flux and triggers automations (e.g. sprinkler activates when temperature exceeds 25°C); Node-RED provides the live dashboard. All broker services containerized with Docker Compose.',
        technologies: ['Python', 'MQTT', 'InfluxDB', 'Home Assistant', 'Telegraf', 'Node-RED', 'Docker'],
        image_url: '',
        live_url: '',
        github_url: '',
        featured: false,
        order_index: 6,
      },
    ];

    const sorted = [...projects].sort((a, b) => (a?.[orderBy] ?? 0) - (b?.[orderBy] ?? 0));
    return sorted.slice(0, limit ?? sorted.length);
  }
};